import { message, notification } from "antd";
import { convertServiceFormToApiValues } from "../Helpers/ServiceHelpers";
import { APIResponseStatus, ServiceActions } from "../Constants/Constants";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Service ${
      action === ServiceActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ServiceActions.add ? "adding" : "updating"
  } Service`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const { action, record, serviceApi } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history: props.history,
      preProcess: () => setProcessing(false),
      errorCallback: () => message.error(failMessage),
      successCallback: (data) => {
        if (data.status === APIResponseStatus.fail) {
          if (data.info === "ExistingService") {
            notification["error"]({
              message: `Error creating Service`,
              description: `Service name already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({ redirect: action === ServiceActions.add });
        }
      },
    });
    try {
      setProcessing(true);
      values.id = record?.serviceId;
      const formattedData = convertServiceFormToApiValues(values, action);
      console.log("onSubmit formattedData", formattedData);
      if (action === ServiceActions.add) {
        serviceApi.addService(formattedData, formSubmitCallback);
      } else {
        serviceApi.updateService(formattedData, formSubmitCallback);
      }
    } catch (error) {
      message.error(failMessage);
      setProcessing(false);
    }
  };
